import { getChromeAction } from '../chrome/wrappers';
import { getProtectionStatus, ProtectionStatus } from '../protectionStatus';
import { getSafeNetworksStore } from '../storage/stores';
import { getOrganisationName } from '../types/store/safeNetworks';

/*
 * Sets the popup content according to the current protection state.
 */
export const updateProtectionPopup = () => {
  const status = getProtectionStatus();
  switch (status) {
    case 'protected':
    case 'delegation_stopped':
      return setProtectionPopup(status);
    case 'safe_network_delegated':
      const safeNetwork = getSafeNetworksStore().getActiveSafeNetwork();
      return setProtectionPopup(status, getOrganisationName(safeNetwork));
    case 'unprotected':
      return unsetProtectionPopup();
  }
};

const setProtectionPopup = (
  state: ProtectionStatus,
  organisationName?: string
) => {
  if (organisationName) {
    return getChromeAction().setPopup({
      popup: `protectionPopup.html#/${state}?organisation_name=${encodeURIComponent(
        organisationName
      )}`,
    });
  }
  return getChromeAction().setPopup({
    popup: `protectionPopup.html#/${state}`,
  });
};

const unsetProtectionPopup = () => getChromeAction().setPopup({ popup: '' });
